export const senators = [
  {
    state: "ABIA",
    name: "Sen. E. Abaribe",
    email: "enyiabaribe@yahoo.com",
    phone: "08033129452",
  },
  {
    state: "ABIA",
    name: "Sen. O. Kalu",
    email: "okalu@orjikalu.com",
    phone: "08034000001",
  },
  {
    state: "ABIA",
    name: "Sen. T. Orji",
    email: "senatortaorji@gmail.com",
    phone: "07082800000",
  },
  {
    state: "ADAMAWA",
    name: "Sen. B. Yaroe",
    email: "bdyaroe@gmail.com",
    phone: "08034050460",
  },
  {
    state: "ADAMAWA",
    name: "Sen. I. Abbo",
    email: "faradugun@gmail.com",
    phone: "08066285112",
  },
  {
    state: "ADAMAWA",
    name: "Sen. A. Ahmed",
    email: "aishatu.ahmed@nass.gov.ng",
    phone: "No Phone number",
  },
  {
    state: "AKWA IBOM",
    name: "Sen. B. Akpan",
    email: "akpanalbert@hotmail.com",
    phone: "08055555188",
  },
  {
    state: "AKWA IBOM",
    name: "Sen. A. Eyakenyi",
    email: "konssie@yahoo.com",
    phone: "08035054282",
  },
  {
    state: "AKWA IBOM",
    name: "Sen. C. Ekpeyong",
    email: "chrisekpesg@yahoo.com",
    phone: "08027785234",
  },
  {
    state: "ANAMBRA",
    name: "Sen. I. Ubah",
    email: "senatorifeanyiubah@gmail.com",
    phone: "09096655596",
  },
  {
    state: "ANAMBRA",
    name: "Sen. E. Uche",
    email: "u.ekwunife@yahoo.com",
    phone: "08037620002",
  },
  {
    state: "ANAMBRA",
    name: "Sen. A. Oduah",
    email: "senatorstella@gmail.com",
    phone: "08055084340",
  },
  {
    state: "BAUCHI",
    name: "Sen. H. Jika",
    email: "jikahalliru@gmail.com",
    phone: "08038666690",
  },
  {
    state: "BAUCHI",
    name: "Sen. A. Bulkachuwa",
    email: "adamu.bulkachuwa@nass.gov.ng",
    phone: "No Phone number",
  },
  {
    state: "BAUCHI",
    name: "Sen. L. Gumau",
    email: "lawal.gumau@nass.gov.ng",
    phone: "No Phone number",
  },
  {
    state: "BAYELSA",
    name: "Sen. O. EWHRUDJAKPO",
    email: "ogagadick@gmail.com",
    phone: "09031352791",
  },
  {
    state: "BAYELSA",
    name: "Sen. D. Diri",
    email: "douyediri@gmail.com",
    phone: "08036668698",
  },
  {
    state: "BAYELSA",
    name: "Sen. D. Wangagra",
    email: "degi.wangagha@nass.gov.ng",
    phone: "No Phone number",
  },
  {
    state: "BENUE",
    name: "Sen. E. Orker-Jev",
    email: "emmanuel.orkerjev@nass.gov.ng",
    phone: "No Phone number",
  },
  {
    state: "BENUE",
    name: "Sen A. Morro",
    email: "abahmoro@yahoo.com",
    phone: "No Phone number",
  },
  {
    state: "BORNO",
    name: "Sen. A. Kyari",
    email: "abubakar.kyari@nass.gov.ng",
    phone: "No Phone number",
  },
  {
    state: "BORNO",
    name: "Sen. K. Shettima",
    email: "kashimshettima@gmail.com",
    phone: "08034459047",
  },
  {
    state: "BORNO",
    name: "Sen. M. Ndume",
    email: "mohammed.ndume@nass.gov.ng",
    phone: "08109480004",
  },
  {
    state: "CROSS RIVER",
    name: "Sen. R. Oko",
    email: "rose.oko@nass.gov.ng",
    phone: "No Phone number",
  },
  {
    state: "CROSS RIVER",
    name: "Sen. G. Bassey",
    email: "gershombassey@gmail.com",
    phone: "08034444555",
  },
  {
    state: "CROSS RIVER",
    name: "Sen. S. Onor",
    email: "irunandu@yahoo.com",
    phone: "08030998460",
  },
  {
    state: "DELTA",
    name: "Sen. O. Omo-Agege",
    email: "senator.ovieomoagege@gmail.com",
    phone: "07033399937",
  },
  {
    state: "DELTA",
    name: "Sen. J. Manager",
    email: "jamesmanager2013@gmail.com",
    phone: "08143103829",
  },
  {
    state: "DELTA",
    name: "Sen. P. Nwaoboshi",
    email: "pnwaoboshi@yahoo.com",
    phone: "08037200999",
  },
  {
    state: "EDO",
    name: "Sen. C. Ordia",
    email: "engineercliffordordia@gmail.com",
    phone: "08038403877",
  },
  {
    state: "EDO",
    name: "Sen. F. Alimikhena",
    email: "falimikhena@yahoo.com",
    phone: "08155555884",
  },
  {
    state: "EDO",
    name: "Sen. M. Urhoghide",
    email: "matthewurhoghide@yahoo.com",
    phone: "08033855557",
  },
  {
    state: "EKITI",
    name: "Sen. A. Adeyeye",
    email: "dadeyeye34@gmail.com",
    phone: "08023051100",
  },
  {
    state: "EKITI",
    name: "Sen. O. Adetumbi",
    email: "senator.adetunmbi@gmail.com",
    phone: "08064487689",
  },
  {
    state: "EKITI",
    name: "Sen. M. Bamidele",
    email: "amicusng@gmail.com",
    phone: "080911112",
  },
  {
    state: "ENUGU",
    name: "Sen. C. Nnamani",
    email: "ebeanoglobal875@gmail.com",
    phone: "08022255522",
  },
  {
    state: "ENUGU",
    name: "Sen. Ikweremadu",
    email: "ikeekweremadu@yahoo.com",
    phone: "08075757000",
  },
  {
    state: "ENUGU",
    name: "Sen. C. Utazi",
    email: "chukwuka.utazi@nass.gov.ng",
    phone: "No Phone number",
  },
  {
    state: "GOMBE",
    name: "Sen. A. Kilawangs",
    email: "amos.kilawangs@nass.gov.ng",
    phone: "No Phone number",
  },
  {
    state: "GOMBE",
    name: "Sen. D. Mohammed",
    email: "mdgoje1@gmail.com",
    phone: "07068686699",
  },
  {
    state: "GOMBE",
    name: "Sen. S. Alkali",
    email: "saidualkali905@gmail.com",
    phone: "08026032222",
  },
  {
    state: "EBONYI",
    name: "Sen. S. Egwu",
    phone: "08039665848",
    email: "drsamominyiegwu@gmail.com",
  },
  {
    state: "EBONYI",
    name: "Sen. J. Ogba",
    phone: "08037791346",
    email: "onwaigboasa@yahoo.com",
  },
  {
    state: "EBONYI",
    name: "Sen. M. Nnachi",
    phone: "08034528595",
    email: "michaelamannachi@gmail.com",
  },
  {
    state: "IMO",
    name: "Sen. E. Onyewuchi",
    phone: "08032012132",
    email: "ezeonyewuchi@gmail.com",
  },
  {
    state: "IMO",
    name: "Sen. R. Okorocha",
    email: "rochas.okorocha@nass.gov.ng",
  },
  {
    state: "IMO",
    name: "Sen. B. Uwajumogu",
    email: "benjamin.uwajumogu@nass.gov.ng",
  },
  {
    state: "JIGAWA",
    name: "Sen. D. Sankara",
    phone: "08037032577",
    email: "dsankara@yahoo.co.uk",
  },
  {
    state: "JIGAWA",
    name: "Sen. S. Mohammed",
    phone: "08022902648",
    email: "nakudu@yahoo.com",
  },
  {
    state: "JIGAWA",
    name: "Sen. I. Hadejia",
    email: "ibrahim.hadejia@nass.gov.ng",
  },
  {
    state: "KADUNA",
    name: "Sen. S. Kwari",
    phone: "08033019005",
    email: "suleimankwari@yahoo.com",
  },
  {
    state: "KADUNA",
    name: "Sen. D. La'ah",
    phone: "08118887772",
    email: "laah.danjuma@yahoo.com",
  },
  {
    state: "KANO",
    name: "Sen. K. Gaya",
    email: "abiru.gaya@nass.gov.ng",
  },
  {
    state: "KANO",
    name: "Sen. I. Jibrin",
    email: "ibrahim.jibrin@nass.gov.ng",
  },
  {
    state: "KANO",
    name: "Sen. I. Shekarau",
    phone: "08099199111",
    email: "ishekarau55@yahoo.com",
  },
  {
    state: "KATSINA",
    name: "Sen. A. Babba-Kaita",
    email: "ahmad.babba@nass.gov.ng",
  },
  {
    state: "KATSINA",
    name: "Sen. B. Mandiya",
    email: "bellom2001@yahoo.com",
  },
  {
    state: "KATSINA",
    name: "Sen. K. Barkiya",
    phone: "08138360742",
    email: "barkamazadu00@yahoo.com",
  },
  {
    state: "KEBBI",
    name: "Sen. M. Aliero",
    phone: "07066847000",
    email: "senatoraliero@yahoo.com",
  },
  {
    state: "KEBBI",
    name: "Sen. Y. Abdullahi",
    email: "yahaya.abdullahi@nass.gov.ng",
  },
  {
    state: "KEBBI",
    name: "Sen. B. Na'Allah",
    email: "bala.naallah@nass.gov.ng",
  },
  {
    state: "KOGI",
    name: "Sen. J. Isah",
    phone: "08185651909",
    email: "isahj@ymail.com",
  },
  {
    state: "KOGI",
    name: "Sen. O. Yakubu",
    phone: "07032642674",
    email: "yakubu.oseni75@yahoo.com",
  },
  {
    state: "KWARA",
    name: "Sen. A. Yisa",
    phone: "07055221111",
    email: "ylashiru@gmail.com",
  },
  {
    state: "KWARA",
    name: "Sen. S. Umar",
    email: "sadiq.umar@nass.gov.ng",
  },
  {
    state: "KWARA",
    name: "Sen. I. Oloriegbe",
    phone: "08033581695",
    email: "oloridoc@yahoo.com",
  },
  {
    state: "LAGOS",
    name: "Sen. Oluremi Tinubu",
    phone: "08095300251",
    email: "info@oluremitinubu.com",
  },
  {
    state: "LAGOS",
    name: "Sen. S. Osinowo",
    phone: "08033049369",
    email: "bayoosinowo@gmail.com",
  },
  {
    state: "LAGOS",
    name: "Sen. S. Adeola",
    phone: "08074000040",
    email: "adeolaolamilekan2005@yahoo.com",
  },
  {
    state: "NASARAWA",
    name: "Sen. A. Adamu",
    email: "abdullahi.adamu@nass.gov.ng",
  },
  {
    state: "NASARAWA",
    name: "Sen. G. Awkashiki",
    phone: "08099321703",
    email: "godiyaakwashiki123@gmail.com",
  },
  {
    state: "NASARAWA",
    name: "Sen. U. Almakura",
    phone: "08077253989",
    email: "tankoalmakura@yahoo.co.uk",
  },
  {
    state: "NIGER",
    name: "Sen. ALIYU ABDULLAHI - THE SPONSOR OF THE BILL",
    phone: "08052046555",
    email: "draliyuabdullahii@gmail.com",
  },
  {
    state: "NIGER",
    name: "Sen. M. Bima",
    phone: "08173479797",
    email: "sangibima@gmail.com",
  },
  {
    state: "NIGER",
    name: "Sen. M. Musa",
    phone: "08033114615",
    email: "Sani_313@hotmail.com",
  },
  {
    state: "OGUN",
    name: "Sen. R. Mustapha",
    phone: "08033047403",
    email: "adeoshy@gmail.com",
  },
  {
    state: "OGUN",
    name: "Sen. I. Amosun",
    phone: "08033213993",
    email: "amks2@yahoo.com",
  },
  {
    state: "OGUN",
    name: "Sen. T. Odebiyi",
    phone: "08036058080",
    email: "toluodebiyi@gmail.com",
  },
  {
    state: "ONDO",
    name: "Sen. A. Akinyelure",
    phone: "08091707000 ",
    email: "akinyelure1@yahoo.com",
  },
  {
    state: "ONDO",
    name: "Sen. N. Tofowomo",
    phone: "08054546666",
    email: "tofowomo_1960@yahoo.com",
  },
  {
    state: "ONDO",
    name: "Sen. R. Boroffice",
    phone: "08176406557",
    email: "rboroffice@yahoo.com",
  },
  {
    state: "0SUN",
    name: "Sen. S. Basiru",
    phone: "08034753343",
    email: "ajibolabasiru@hotmail.com",
  },
  {
    state: "0SUN",
    name: "Sen. F. Fadahunsi",
    phone: "08052242211",
    email: "adefadahunsi19@gmail.com",
  },
  {
    state: "0SUN",
    name: "Sen. A. Oriolowo",
    phone: "08033565979",
    email: "yemlee12@gmail.com",
  },
  {
    state: "OYO",
    name: "Sen. T. Folarin",
    phone: "08033160587",
    email: "teslimkfolarin@yahoo.com",
  },
  {
    state: "OYO",
    name: "Sen. B. Omotayo",
    phone: "08037053375",
    email: "rabab1004@yahoo.com",
  },
  {
    state: "OYO",
    name: "Sen. A. Balogun",
    phone: "08132956057",
    email: "kbalogun7707@gmail.com",
  },
  {
    state: "PLATEAU",
    name: "Senator I. Longjan",
    phone: "07044442045",
    email: "talk2longjan@gmail.com",
  },
  {
    state: "PLATEAU",
    name: "Sen. H. Dimka",
    phone: "08033359443",
    email: "dewansamson4@gmail.com",
  },
  {
    state: "PLATEAU",
    name: "Sen. I. Gyang",
    phone: "08097777712",
    email: "dridgyang@gmail.com",
  },
  {
    state: "RIVERS",
    name: "Sen. B. Apiafi",
    email: "betty.apiafi@nass.gov.ng",
  },
  {
    state: "RIVERS",
    name: "Sen. G. Sekibo",
    email: "george.sekibo@nass.gov.ng",
  },
  {
    state: "RIVERS",
    name: "Sen. B. Mpigi",
    phone: "08037419000",
    email: "mpigib@yahoo.com",
  },
];
